import type { FC } from 'react';

interface Props {
  fileUrl: string;
}

const PhotoViewer: FC<Props> = ({ fileUrl }) => {
  return <img alt={fileUrl} className="max-w-full" src={fileUrl} />;
};

export default PhotoViewer;
